// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"card_card-wrapper__ZrAIw","card-border":"card_card-border__uX6Kz","card-content":"card_card-content__uUXmk","card-bg":"card_card-bg__DoPrI"};